import { render } from "./OccupationDisease.vue?vue&type=template&id=612a8370&scoped=true"
import script from "./OccupationDisease.vue?vue&type=script&lang=js"
export * from "./OccupationDisease.vue?vue&type=script&lang=js"

import "./OccupationDisease.vue?vue&type=style&index=0&id=612a8370&lang=scss&scoped=true"
import "./OccupationDisease.vue?vue&type=style&index=1&id=612a8370&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612a8370"]])

export default __exports__